import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton } from "../../components/neu/Neu";
import { OfficialDocButton } from "../../components/docs/OfficialDocButton";
import { downloadInvoiceXml, issueInvoice, preflight, voidInvoice, payInvoice } from "../../api/salesInvoices";

// أفعال الفاتورة: تدقيق PINT ثم الإصدار، تنزيل XML، الدفع، والإبطال.
export const InvoiceActions = ({ doc, onDone }) => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);

  const run = async (fn, key) => {
    setBusy(true);
    try {
      const result = await fn();
      if (result?.problems?.length) {
        toast.error(result.problems.map((p) => `${p.rule}: ${p.message}`).join(" · "));
      } else {
        toast.success(t(`sales.invoice.done.${key}`));
      }
      onDone?.();
    } catch (error) {
      const detail = error?.response?.data?.detail;
      toast.error(detail?.problems ? detail.problems.map((p) => p.message).join(" · ")
        : detail?.code || t("errors.generic"));
    }
    setBusy(false);
  };

  return (
    <div className="flex flex-wrap gap-2" data-testid="invoice-actions">
      {doc.state === "draft" ? (
        <>
          <NeuButton className="px-3 py-2 text-xs" data-testid="invoice-preflight"
                     disabled={busy} onClick={() => run(() => preflight(doc.id), "preflight")}>
            {t("sales.invoice.preflight")}
          </NeuButton>
          <NeuButton variant="primary" className="px-3 py-2 text-xs" data-testid="invoice-issue"
                     disabled={busy} onClick={() => run(() => issueInvoice(doc.id), "issued")}>
            {t("sales.invoice.issue")}
          </NeuButton>
        </>
      ) : null}
      <OfficialDocButton kind="sales_invoice" docId={doc.id} testId="invoice-official-print"
                         label={t("docs.openOfficial")} />
      {doc.number ? (
        <NeuButton className="px-3 py-2 text-xs" data-testid="invoice-xml"
                   onClick={() => downloadInvoiceXml(doc.id, doc.number)}>
          {t("sales.invoice.xml")}
        </NeuButton>
      ) : null}
      {["issued", "partially_paid", "overdue"].includes(doc.state) ? (
        <>
          <NeuButton className="px-3 py-2 text-xs" data-testid="invoice-pay" disabled={busy}
                     onClick={() => run(() => payInvoice(doc.id, doc.totals?.payable, true), "paid")}>
            {t("sales.invoice.pay")}
          </NeuButton>
          <NeuButton variant="danger" className="px-3 py-2 text-xs" data-testid="invoice-void" disabled={busy}
                     onClick={() => run(() => voidInvoice(doc.id, t("sales.defaultReason")), "void")}>
            {t("sales.invoice.void")}
          </NeuButton>
        </>
      ) : null}
    </div>
  );
};
